import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AwsAmplifyService } from '@app/services/aws-amplify.service';
import { from, switchMap } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
    const awsAmplifyService = inject(AwsAmplifyService);
    return from(awsAmplifyService.getToken()).pipe(
        switchMap(token => {
            const authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return next(authReq);
        }),
    );
};
